export default __webpack_public_path__ + "static/media/katesbreakfast.d7113566.png";